import { Box, Grid2 as Grid, Typography } from '@mui/material';

import MobileContentBG from '../../assets/mobileContentBG.png';
import React from 'react';
import content_Bg from '../../assets/ContentBG.webp';
import teamImg from '../../assets/team.png';

interface TeamProps {
  isMobile?: Boolean | null;
}

const Team: React.FC<TeamProps> = ({ isMobile }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden'
      }}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          size={{ xs: 12, md: 8 }}
          sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Box p={6}>
            <Typography
              style={{
                fontFamily: 'Bevan',
                fontSize: '48px',
                lineHeight: '1'
              }}>
              <span style={{ color: 'white' }}>{`“ `}</span>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {` The Ultimate Team`}
              </span>
            </Typography>
            <Typography
              style={{
                fontFamily: 'Bevan',
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '48px'
              }}>
              {`Spirit - Join a Clan`}
            </Typography>
            <Typography
              style={{
                fontFamily: 'Bevan',
                fontSize: '48px'
              }}>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {`Rule the Game! `}
              </span>

              <span style={{ color: 'white' }}>{`”`}</span>
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Baloo2',
                color: '#fff',
                whiteSpace: 'pre-line',
                fontSize: '19px'
              }}>
              No champion stands alone! Team up with friends, form clans,{'\n'}
              and take on creative challenges together. Earn exclusive clan badges,{'\n'}
              unlock special perks, and build a legendary name in the {'\n'}
              Champsverse! The more you collaborate, the bigger you rise!
            </Typography>
          </Box>
        </Grid>

        <Grid
          size={{ xs: 12, md: 8 }}
          sx={{
            display: { xs: 'block', md: 'none' },
            margin: '30px 0'
          }}>
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span style={{ color: 'white' }}>{`“ `}</span>
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {`  The Ultimate Team`}
            </span>
          </Typography>

          <Typography
            fontSize={20}
            fontWeight={800}
            fontFamily={'Bevan'}
            align="center"
            sx={{
              background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
            Spirit - Join a Clan
          </Typography>
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {`Rule the Game! `}
            </span>

            <span style={{ color: 'white' }}>{`”`}</span>
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Baloo2',
              fontWeight: 500,
              fontSize: '15px',
              pt: '10px',
              color: 'white',
              textAlign: 'center',
              margin: '0 40px'
            }}>
            No champion stands alone! Team up with friends, form clans,{'\n'}
            and take on creative challenges together. Earn exclusive clan badges,{'\n'}
            unlock special perks, and build a legendary name in the {'\n'}
            Champsverse! The more you collaborate, the bigger you rise!
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <img
              src={teamImg}
              alt="learning"
              style={{
                width: isMobile ? '305px' : 570,
                height: isMobile ? '305px' : 570
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Team;
